import {
  defineStyle,
  defineStyleConfig,
  StyleFunctionProps,
} from "@chakra-ui/react"
import { extendTheme, type ThemeConfig } from "@chakra-ui/react"
//import { mode } from "@chakra-ui/theme-tools"

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false,
}

const globalStyles = {
  styles: {
    global: (props: StyleFunctionProps) => ({
      body: {
        fontFamily: "body",
        //color: mode('gray.800', 'whiteAlpha.900')(props),
        color: "dmazegray.900",
        bg: "dmazegray.50",
        lineHeight: "base",
      },
      p: {
        marginTop: "10px",
      },
      ".toolong": {
        borderColor: "red.500",
        boxShadow: "0 0 0 1px red.500",
        animation: "blink 0.2s",
      },
      "@keyframes blink": {
        "0%": {
          borderColor: "rgba(255, 0, 0, 0)",
          boxShadow: "rgba(255, 0, 0, 0)",
        },
        "50%": {
          borderColor: "rgba(255, 0, 0, 0.5)",
          boxShadow: "rgba(255, 0, 0, 0.5)",
        },
        "100%": {
          borderColor: "rgba(255, 0, 0, 1)",
          boxShadow: "rgba(255, 0, 0, 1)",
        },
      },
    }),
  },
}

const dmazeTextArea = defineStyle({
  border: "1px",
  borderRadius: 10,
  fontStyle: "italic",
  backgroundColor: "dmazegray.100",
  color: "dmazegray.900",
  h: "180px",
  boxShadow: "0 4px 15px 7px rgba(139, 139, 139, 0.03)",
  focusBorderColor: "dmazespecial.400",
  _focusVisible: {
    borderColor: "dmazespecial.400",
    boxShadow: "0 4px 15px 7px rgba(139, 139, 139, 0.03)",
  },
  ".toolong": {
    borderColor: "red.500",
    boxShadow: "0 0 0 1px red.500",
  },
})

const dmazeButton = defineStyle({
  bg: "dmazespecial.600",
  color: "white",
  borderRadius: "50px",
  padding: "10px 24px",
  h: "56px",
  _hover: {
    backgroundImage: "linear-gradient(rgb(0 0 0/10%) 0 0)",
    bg: "dmazespecial.600",
  },
})

const dmazeLinkButton = defineStyle({
  color: "dmazegray.800",
})

const dmazeHeading = defineStyle({
  color: "dmazespecial.600",
  alignSelf: "start",
  fontWeight: "normal",
})

const headingTheme = defineStyleConfig({
  defaultProps: {
    variant: "dmazeHeading",
  },
  variants: { dmazeHeading: dmazeHeading },
})

const buttonTheme = defineStyleConfig({
  variants: { solid: dmazeButton, link: dmazeLinkButton },
})

export const textareaTheme = defineStyleConfig({
  variants: { outline: dmazeTextArea },
})
const customThemeConfig = {
  colors: {
    white: "#FFFFFF",
    dmazegray: {
      "50": "#F3F4F5",
      "100": "#F9FAFA", //Text
      "200": "#e0e4e8",
      "300": "#E0E4E8",
      "400": "#C2C9D1", //Text dark
      "500": "#4F4F5A",
      "600": "#233558DE",
      "700": "#91979D",
      "800": "#616568",
      "900": "#353541",
    },
    dmazespecial: {
      "50": "#FFFFFF",
      "100": "#FFFFFF",
      "200": "#FFFFFF",
      "300": "#FFFFFF",
      "400": "#05A69D",
      "500": "#048F88",
      "600": "#049890",
      "700": "#FFFFFF",
      "800": "#FFFFFF",
      "900": "#FFFFFF",
    },
  },
  defaultProps: {
    size: "lg", // default is md
    variant: "sm", // default is solid
    colorScheme: "dmazegray", // default is gray
    color: "dmazegray.200",
    bg: "dmazegray.900",
  },
  components: {
    Textarea: textareaTheme,
    Button: buttonTheme,
    Heading: headingTheme,
  },
  initialColorMode: "dark",
  useSystemColorMode: false,
}

// 3. extend the theme
const theme = extendTheme({ ...customThemeConfig, ...globalStyles, ...config })

export default theme
